import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import SiteInternetApp from "../components/Page/SiteInternetApp";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import picture from "./img/website.jpg";
import config from "../../data/SiteConfig";
import Contact from "../components/Contact/Contact";
import "./page.scss";

export default class SiteInternet extends Component {
  render() {
    // SEO PURPOSES
    const { slug } = this.props.pathContext;


    const postNode = {
        "frontmatter": {
            "title": "Création de sites internet exclusifs",
            "description":  "Integral Service vous accompagne dans la création de votre site Internet sur-mesure. Chez nous tout est fait à la main pour que le site réponde à 100% de votre besoin.",
            "cover": picture
        }
    };

    let title = "Site Internet";
    let description = "Des sites Internet rapides et sublimes";
    let goto = "En découvrir plus";

    return (
      <div className="webapp-container page-details">
          <Header/>
          <Menu />
          <Helmet 
          title={`Création de site Internet | ${config.siteTitle}`}
          description = {`Integral Service vous accompagne dans la création de votre site Internet sur-mesure. Chez nous tout est fait à la main pour que le site réponde à 100% de votre besoin.`}
          />
          <SEO postPath={slug} postNode={postNode} postSEO />
          <HeaderPage title={title} description={description} picture={picture} />
          <SiteInternetApp />
          <Contact />
          <SocialLinks postPath={slug} postNode={postNode} />
          <Footer />
      </div>
    );
  }
}
;


// WEBPACK FOOTER //
// ./src/pages/site-internet.jsx